import { toasts } from 'svelte-toasts';
export const showToast = (toastProps) => {
    const { title, description, theme, placement, duration, type } = toastProps;
    toasts.add({
        title,
        description,
        duration: duration || 2500, // 0 or negative to avoid auto-remove
        theme: theme || 'light',
        placement: placement || 'top-center',
        type: type,
        onClick: () => { },
        onRemove: () => { }
    });
};
